<template>
  <Layout title="Transport Voucher" description="Review and manage transport vouchers">
    <div class="container py-5" style="max-width: 1100px;">
      <div class="card shadow">
        <div class="card-header bg-dark text-light d-flex justify-content-between align-items-center">
          <div>
            <h3 class="mb-0">Transport Voucher</h3>
            <small class="text-muted">Fill in and save the transport voucher below</small>
          </div>
        </div>

        <div class="card-body">
          <!-- VOUCHER CANVAS -->
          <div class="row g-2 mb-4 small">
            <div class="col-md-4"><label>Vessel</label><input v-model="form.vessel" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>PIC</label><input v-model="form.pic" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Driver</label><input v-model="form.driver" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Date</label><input v-model="form.date" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Time</label><input v-model="form.time" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Vehicle No.</label><input v-model="form.vehicleNo" class="form-control form-control-sm" /></div>
            <div class="col-md-6"><label>From</label><input v-model="form.from" class="form-control form-control-sm" /></div>
            <div class="col-md-6"><label>To</label><input v-model="form.to" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Crew</label><input v-model="form.crew" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Pax</label><input v-model="form.pax" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Flight</label><input v-model="form.flight" class="form-control form-control-sm" /></div>
            <div class="col-12"><label>Remarks</label><textarea v-model="form.remarks" class="form-control form-control-sm"></textarea></div>
          </div>

          <!-- CHARGES SECTION -->
            <hr class="my-4" />
            <h5 class="fw-bold mb-3">Charges (SGD)</h5>

            <!-- SWITCHES + VALUES -->
            <div class="row g-3 small align-items-center">
              <!-- Switches -->
              <div class="col-md-12 mb-2">
                <div class="d-flex flex-wrap gap-3">
                  <div v-for="(label, key) in switches" :key="key" class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" v-model="form[key]" :id="key">
                    <label class="form-check-label" :for="key">{{ label }}</label>
                  </div>
                </div>
              </div>

              <!-- Values -->
              <div class="row g-3 small align-items-center">
                <!-- Switches -->
                <!-- <div class="col-md-12 mb-2">
                  <div class="d-flex flex-wrap gap-3">
                    <div v-for="(label, key) in switches" :key="key" class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" v-model="form[key]" :id="key">
                      <label class="form-check-label" :for="key">{{ label }}</label>
                    </div>
                  </div>
                </div> -->

                <!-- Values -->
                <div class="col-md-4" v-for="(label, key) in fields" :key="key">
                  <label>{{ label }}</label>

                  <!-- if waitingValue, string -->
                  <input
                    v-if="key === 'waitingValue'"
                    v-model="form[key]"
                    type="text"
                    class="form-control form-control-sm"
                  />

                </div>
              </div>
              <!-- SIGNATURE SECTION -->
              <hr class="my-4" />
                <h5 class="fw-bold mb-2">Signature</h5>
                <div class="text-center">
                  <canvas
                    ref="signaturePad"
                    class="border rounded bg-white w-100"
                    style="max-width: 750px; height: 130px;"
                    @mousedown="startSign"
                    @mousemove="drawSign"
                    @mouseup="endSign"
                    @mouseleave="endSign"
                    @touchstart.prevent="startSign"
                    @touchmove.prevent="drawSign"
                    @touchend.prevent="endSign"
                  ></canvas>
                  <button class="btn btn-sm btn-outline-secondary mt-2" @click="clearSign">Clear Signature</button>
              </div>


              <div class="col-12 text-center mt-3">
                <button class="btn btn-primary px-4" @click="replaceVoucher" :disabled="isUploading">
                  <span v-if="!isUploading">Save Image</span>
                  <span v-else class="spinner-border spinner-border-sm"></span>
                </button>
              </div>
            </div>

        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import axios from 'axios'
import { useToast } from 'vue-toastification'
import { getAuth,onAuthStateChanged } from 'firebase/auth'
import router from '@/router'

export default {
  name: 'VoucherPage',
  components: { Layout },
  data() {
    return {
      bookingID: '',
      voucherId: '',
      voucherImg: require('@/assets/transportVoucher.jpg'),
      scaleFactor: 0.9,
      isUploading: false,
      // ✅ all editable fields combined (info + charges)
      form: {
            // info
            vessel: '',
            pic: '',
            driver: '',
            date: '',
            time: '',
            vehicleNo: '',
            from: '',
            to: '',
            crew: '',
            pax: '',
            flight: '',
            remarks: '',
            remarks2: '',

            // charges
            tripValue: 0,
            erpValue: 0,
            parkingValue: 0,
            meetingValue: 0,
            midnightValue: 0,
            waitingValue: 0,
            othersValue: 0,
            totalSGD: 0,
            voucherId:"",
            trip: true,
            erp: false,
            parking: false,
            meeting: false,
            midnight: false,
            waiting: false,
            others: false,
      },
      fields: {
        waitingValue: 'Waiting',
      },
      switches: {
        trip: 'Trip',
        erp: 'ERP',
        parking: 'Parking',
        meeting: 'Meeting',
        midnight: 'Midnight',
        waiting: 'Waiting',
        others: 'Others'
      },

    }
  },
  setup() {
    const toast = useToast()
    return { toast }
  },
  
async mounted() {
  this.bookingID = this.$route.params.id
  const now = new Date();
  const mm = String(now.getMonth() + 1).padStart(2, "0"); // 01–12
  const yy = String(now.getFullYear()).slice(-2);         // 25
  const random = Math.random().toString(36).substring(2, 5).toUpperCase();

  this.voucherId = `DRV-${mm}${yy}-${this.$route.params.id}-${random}`;
  
  const auth = getAuth()

  onAuthStateChanged(auth, async (user) => {
    if (!user) {
   
      console.warn('⚠️ No user found, please login')
      this.toast.error('Please login again')
      router.push('/login') // or show a login modal
    }
  })

  
  // ✅ Setup signature pad
  const c = this.$refs.signaturePad
  const rect = c.getBoundingClientRect()
  c.width = rect.width * window.devicePixelRatio
  c.height = rect.height * window.devicePixelRatio
  const ctx = c.getContext('2d')
  ctx.scale(window.devicePixelRatio, window.devicePixelRatio)
  // ✅ preload background voucher image
  const img = new Image()
  img.src = this.voucherImg
  img.onload = () => {
    this.voucherImg = img.src
    this.drawVoucher()
  }

  // ✅ redraw when values change
  Object.keys(this.form).forEach(key => {
    this.$watch(`form.${key}`, this.drawVoucher)
  })
},



  methods: {
    async getAuthHeader() {
      const auth = getAuth()
      const user = auth.currentUser
      if (!user) throw new Error('Not logged in')
      const token = await user.getIdToken(true)
      return { Authorization: token }
    },
    

    checkPageAccess(allowedRoles = []) {
      const access = this.$store.state.systemAccess || {}
      const hasAccess = allowedRoles.some(role => access[role] === true)
      if (!hasAccess) {
        this.$toast.error('Access denied.')
        if (access.admin) this.$router.push('/crm')
        else if (access.client) this.$router.push('/booking')
        else if (access.driver) this.$router.push('/DriverJob')
        else this.$router.push('/')
      }
    },

    drawVoucher() {
      if (!this.voucherImg) return
      const canvas = this.$refs.voucherCanvas
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.src = this.voucherImg

      img.onload = () => {
        const ctx = canvas.getContext('2d')
        canvas.width = img.width * this.scaleFactor
        canvas.height = img.height * this.scaleFactor
        ctx.scale(this.scaleFactor, this.scaleFactor)
        ctx.drawImage(img, 0, 0)
        ctx.fillStyle = 'red'
        ctx.font = '20px Arial'
        ctx.fillText(`${this.voucherId || ''}`, 980, 70)

        ctx.fillStyle = 'black'
        ctx.font = '25px Arial'

        // ✅ Basic Info Section
        ctx.fillText(`${this.form.vessel || ''}`, 130, 170)
        ctx.fillText(`${this.form.pic || ''}`, 540, 170)
        ctx.fillText(`${this.form.driver || ''}`, 980, 170)
        ctx.fillText(`${this.form.vehicleNo || ''}`, 1010, 230)
        ctx.fillText(`${this.form.date || ''}`, 130, 230)
        ctx.fillText(`${this.form.time || ''}`, 560, 230)
        ctx.fillText(`${this.form.from || ''}`, 130, 290)
        ctx.fillText(`${this.form.to || ''}`, 540, 290)
        ctx.fillText(`${this.form.crew || ''}`, 270, 350)
        ctx.fillText(`${this.form.pax || ''}`, 780, 345)
        ctx.fillText(`${this.form.flight || ''}`, 1000, 345)
        ctx.fillText(`${this.form.remarks || ''}`, 150, 405)
        ctx.fillText(`${this.form.remarks2 || ''}`, 150, 455)

        // ✅ Charges Section
        ctx.fillText(this.form.trip? '✔' : '', 290, 520)
        ctx.fillText(this.form.erp? '✔' : '', 290, 560)
        ctx.fillText(this.form.parking? '✔' : '', 290, 595)
        ctx.fillText(this.form.meeting? '✔' : '', 290, 635)
        ctx.fillText(this.form.midnight? '✔' : '', 290, 675)
        ctx.fillText(this.form.waiting? '✔' : '', 290, 710)
        ctx.fillText(this.form.others? '✔' : '', 290, 750)
        
        const signCanvas = this.$refs.signaturePad
        if (signCanvas) {
          const sigImg = new Image()
          sigImg.src = signCanvas.toDataURL('image/png')
          sigImg.onload = () => {
            const sigX = 800
            const sigY = 510
            const sigWidth = 300
            const sigHeight = 120
            ctx.drawImage(sigImg, sigX, sigY, sigWidth, sigHeight)
          }
        }
        
      }
    },
    // async replaceVoucher() {
    //   if (!this.voucherId) {
    //     this.toast.error('Missing voucher ID')
    //     return
    //   }

    //   this.isUploading = true
    //   try {
    //     const headers = await this.getAuthHeader()
    //     const formData = new FormData()

    //     // add text + numeric fields
    //     Object.entries(this.form).forEach(([key, value]) => {
    //       formData.append(key, value ?? 0)
    //     })

    //     // voucher image
    //     // const voucherCanvas = this.$refs.voucherCanvas
    //     // const voucherBlob = await new Promise(resolve =>
    //     //   voucherCanvas.toBlob(resolve, 'image/png')
    //     // )
    //     // if (voucherBlob) {
    //     //   formData.append('file', voucherBlob, `TransportVoucher_${this.voucherId}.png`)
    //     // }

    //     // ✅ signature image (from signaturePad)
    //     const sigCanvas = this.$refs.signaturePad
    //     const sigBlob = await new Promise(resolve =>
    //       sigCanvas.toBlob(resolve, 'image/png')
    //     )
    //     if (sigBlob) {
    //       formData.append('signature', sigBlob, `Signature_${this.voucherId}.png`)
    //     }

    //     formData.append('createdBy', 'admin')

    //     // call the API
    //     const res = await axios.put(
    //       `${this.$apiURL}/api/vouchers/${this.voucherId}/replace`,
    //       formData,
    //       { headers }
    //     )

    //     if (res.data.ok) {
    //       this.toast.success('Voucher updated successfully!')
    //       setTimeout(() => router.push('/DriverJob'), 800)
    //     } else {
    //       this.toast.error(res.data.error || 'Failed to update voucher.')
    //     }
    //   } catch (err) {
    //     console.error('❌ replaceVoucher error:', err)
    //     this.toast.error('Error updating voucher.')
    //   } finally {
    //     this.isUploading = false
    //   }
    // },
    async replaceVoucher() {
      const headers = await this.getAuthHeader()

      // 🔥 generate voucherId first
      const numberRes = await axios.post(
        `${this.$apiURL}/api/voucher/generate-number`,
        {},
        { headers }
      )

      if (!numberRes.data.success) {
        this.toast.error('Failed to generate voucher number')
        this.isUploading = false
        return
      }

      this.voucherId = numberRes.data.voucherNumber
      this.form.voucherId =numberRes.data.voucherNumber
      if (!this.voucherId) {
        this.toast.error('Missing voucher ID')
        return
      }

      this.isUploading = true

      try {
        const headers = await this.getAuthHeader()
        const formData = new FormData()

        // 🔥 attach voucherId explicitly
        formData.append("voucherId", this.voucherId)

        // attach all form fields
        Object.entries(this.form).forEach(([key, value]) => {
          formData.append(key, value ?? 0)
        })

        
        // signature
        const sigCanvas = this.$refs.signaturePad
        const sigBlob = await new Promise(resolve =>
          sigCanvas.toBlob(resolve, 'image/png')
        )

        if (sigBlob) {
          formData.append('signature', sigBlob, `Signature_${this.voucherId}.png`)
        }

        const res = await axios.post(
          `${this.$apiURL}/api/vouchers/manual`,
          formData,
          { headers }
        )

        if (res.data.ok) {
          this.toast.success('Voucher created successfully!')
          setTimeout(() => router.push('/DriverJob'), 800)
        } else {
          this.toast.error(res.data.error || 'Failed to create voucher.')
        }

      } catch (err) {
        console.error('❌ finalizeManualVoucher error:', err)
        this.toast.error('Error creating voucher.')
      } finally {
        this.isUploading = false
      }
    },
    async fetchBooking() {
      try {
        const headers = await this.getAuthHeader()
        const res = await axios.get(`${this.$apiURL}/api/bookings/${this.$route.params.id}`, { headers })
        if (!res.data?.booking) {
          this.toast.error('Booking not found')
          return
        }

        const b = res.data.booking
        this.booking = b

        // ✅ Fill your voucher form from booking data
        this.form.vessel = b.vesselName || b.vessel || ''
        this.form.pic = this.getClientName ? this.getClientName(b.clientId) : (b.pic || '')
        //this.form.driver = b.driverName || (Array.isArray(b.driverIDs) ? b.driverIDs.join(', ') : '')
        if (Array.isArray(b.driverNames) && b.driverNames.length > 0) {
          this.form.driver = b.driverNames.join(" / ")
        } else {
          this.form.driver = ""
        }
        // this.form.vehicleNo = b.vehicleNo || ''
         if (Array.isArray(b.vehicleNo) && b.vehicleNo.length > 0) {
          this.form.vehicleNo = b.vehicleNo.join(" / ")
        } else {
          this.form.vehicleNo = ""
        }
        this.form.from = b.rawStartLocation || b.startLocation || ''
        // this.form.to = b.rawEndLocation || b.endLocation || ''
        this.form.crew = b.crewName || ''
        this.form.pax = b.pax || ''
        this.form.flight = Array.isArray(b.flightNumbers)
          ? b.flightNumbers.map(f => f.flight || f.number).join(', ')
          : b.flight || ''
        this.form.remarks = b.remarks || ''
        this.form.remarks2 = b.remarks2 || ''

        // ✅ Convert startTime to Date + Time fields
        if (b.startTime) {
          const dt = new Date(b.startTime)
          const sg = new Date(dt.toLocaleString('en-US', { timeZone: 'Asia/Singapore' }))
          const yyyy = sg.getFullYear()
          const mm = String(sg.getMonth() + 1).padStart(2, '0')
          const dd = String(sg.getDate()).padStart(2, '0')
          const hh = String(sg.getHours()).padStart(2, '0')
          const min = String(sg.getMinutes()).padStart(2, '0')
          this.form.date = `${dd}/${mm}/${yyyy}`
          this.form.time = `${hh}:${min}`
        } else {
          this.form.date = ''
          this.form.time = ''
        }

      } catch (err) {
        console.error('❌ fetchBooking error:', err)
        this.toast?.error('Error loading booking details')
      }
    },
    startSign(e) {
      const c = this.$refs.signaturePad
      this.signCtx = c.getContext('2d')
      this.signCtx.strokeStyle = 'black'
      this.signCtx.lineWidth = 2

      const rect = c.getBoundingClientRect()
      const pos = e.touches ? e.touches[0] : e
      const x = pos.clientX - rect.left
      const y = pos.clientY - rect.top

      this.signing = true
      this.signCtx.beginPath()
      this.signCtx.moveTo(x, y)
      this.signCtx.lineTo(x + 0.1, y + 0.1)
      this.signCtx.stroke()
    },
    drawSign(e) {
      if (!this.signing) return
      const c = this.$refs.signaturePad
      const rect = c.getBoundingClientRect()
      const pos = e.touches ? e.touches[0] : e
      const x = pos.clientX - rect.left
      const y = pos.clientY - rect.top
      this.signCtx.lineTo(x, y)
      this.signCtx.stroke()
    },
    endSign() {
      if (!this.signing) return
      this.signing = false
      this.signCtx.closePath()
       // 🧠 add this to force voucher re-draw with new signature
      this.drawVoucher()
    },
    clearSign() {
      const c = this.$refs.signaturePad
      const ctx = c.getContext('2d')
      ctx.clearRect(0, 0, c.width, c.height)
    },

  }
}
</script>

<style scoped>
canvas {
  touch-action: none;
}
@media (max-width: 768px) {
  .row.g-3.mb-4 {
    flex-direction: column !important;
  }
  canvas {
    height: auto !important;
  }
}
</style>
